import { cx } from '@platform/core/lib/cx';
import type { IModuleTileProps } from './IModuleTileProps';
import { ICON_SPRITE_URL } from './iconSprite';
import { moduleTileMetrics } from './moduleTileMetrics';

/**
 * Плитка модуля (UIUX/foundations/icons): квадрат із двоколірним градієнтом тону категорії (145°, токени --tone-<ключ>;
 * невідомий тон — core) і білою іконкою Lucide посередині, як у каталозі й меню прототипу v4.
 */
export function ModuleTile({ icon, tone, size = 26, title, raised = false, className }: IModuleTileProps) {
  const { radius, glyph } = moduleTileMetrics(size);
  return (
    <span className={cx('module-tile', raised && 'module-tile--raised', className)} title={title} role={title ? 'img' : undefined}
      aria-label={title} aria-hidden={title ? undefined : true}
      style={{ width: size, height: size, borderRadius: radius, background: `linear-gradient(145deg, var(--tone-${tone}, var(--tone-core)))` }}>
      <svg width={glyph} height={glyph} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden>
        <use href={`${ICON_SPRITE_URL}#${icon}`} />
      </svg>
    </span>
  );
}
